export const Button=({onClick,text})=>{
return<button className="mrep_btn btn bg-mrep text-white" type="button" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
{text}
</button>
}